export default "__VITE_ASSET__DSvNLrKk__"